import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaShare,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog = () => {
  // Données du blog avec le contenu du document Word
  const blogPost = {
    id: 1,
    title:
      "Votre guide pour saisir les opportunités au Bénin : L'âge d'or des PME",
    excerpt:
      "Découvrez les opportunités exceptionnelles offertes par l'écosystème béninois : ADPME, PSIE, Label Start Up et Sèmè City. Un guide complet pour structurer votre entreprise et bénéficier des programmes de soutien.",
    content: `
      <p class="lead">Les Petites et Moyennes Entreprises (PME) sont au cœur de la stratégie de développement du Bénin. Plus qu'un slogan, cette affirmation se matérialise par le lancement d'un ambitieux plan stratégique 2025-2029 par le gouvernement. L'objectif est clair : bâtir un écosystème où les PME peuvent naître, grandir et prospérer de manière durable.</p>
      
      <p>Pour les entrepreneurs, cela se traduit par une vague d'opportunités concrètes, portées par des agences et des programmes dédiés. De l'ADPME à Sèmè City, en passant par le PSIE et le Label Start Up, des portes s'ouvrent. Ce guide vous aide à comprendre qui fait quoi et comment positionner votre entreprise pour en bénéficier pleinement.</p>
      
      <h3>1. L'ADPME : Votre porte d'entrée et guichet unique</h3>
      <p>L'Agence de Développement des Petites et Moyennes Entreprises (ADPME) est le bras opérationnel de la politique de l'État pour les PME. C'est votre premier interlocuteur, le point de contact central pour accéder à une multitude de services.</p>
      
      <h4>Opportunités offertes :</h4>
      <ul>
        <li><strong>Accompagnement et Formalisation :</strong> Aide pour passer du secteur informel au formel, une étape clé pour accéder aux marchés publics et aux financements.</li>
        <li><strong>Renforcement de capacités :</strong> Accès à des formations ciblées sur la gestion financière, le marketing, le numérique et la gouvernance d'entreprise.</li>
        <li><strong>Facilitation de l'accès au financement :</strong> L'ADPME ne finance pas directement, mais elle aide à monter des dossiers de crédit solides et oriente vers les institutions financières et les fonds de garantie partenaires.</li>
        <li><strong>Mise en réseau :</strong> Participation à des événements comme le "Mois de l'Entrepreneuriat au Bénin" (MEB) pour trouver des clients, des fournisseurs ou des partenaires.</li>
      </ul>
      
      <h3>2. PSIE : Le levier pour l'emploi des jeunes qualifiés</h3>
      <p>Le Projet de Soutien à l'Inclusion et à l'Emploi (PSIE), souvent désigné par son ancien nom "Projet d'Inclusion des Jeunes" (ProDIJ), est une initiative majeure soutenue par la Banque mondiale. Son objectif est de connecter les jeunes diplômés avec le monde du travail.</p>
      
      <h4>Opportunités pour votre PME :</h4>
      <ul>
        <li><strong>Prise en charge des salaires :</strong> Le PSIE peut prendre en charge une partie significative (souvent jusqu'à 70% ou plus) du salaire des jeunes diplômés que vous recrutez pour une période déterminée (généralement 6 à 12 mois).</li>
        <li><strong>Accès à des compétences fraîches :</strong> C'est une occasion en or de recruter des talents qualifiés à moindre coût pour accélérer votre développement, que ce soit en marketing digital, en comptabilité ou en technologie.</li>
        <li><strong>Formation complémentaire :</strong> Le projet assure souvent une formation d'appoint pour les jeunes avant leur intégration, garantissant leur adéquation avec les besoins de l'entreprise.</li>
      </ul>
      
      <h3>3. Label "Start Up Bénin" : Le passeport pour les innovateurs</h3>
      <p>Lancé en 2023, le Label "Start Up" vise à identifier et à promouvoir les jeunes entreprises à fort potentiel de croissance et d'innovation. Obtenir ce label n'est pas qu'une simple reconnaissance, c'est un véritable accélérateur.</p>
      
      <h4>Opportunités offertes aux entreprises labellisées :</h4>
      <ul>
        <li><strong>Avantages fiscaux et douaniers :</strong> Les startups labellisées bénéficient d'exonérations significatives, notamment sur l'impôt sur les sociétés (IS) et la patente durant leurs premières années.</li>
        <li><strong>Accès prioritaire aux financements :</strong> Le label sert de "sceau de confiance" qui facilite grandement l'accès aux fonds d'investissement publics et privés.</li>
        <li><strong>Soutien à l'internationalisation :</strong> Aide pour participer à des salons internationaux, des missions commerciales et pour protéger la propriété intellectuelle (brevets, marques).</li>
      </ul>
      
      <h3>4. Sèmè City : L'écosystème de l'excellence et de l'innovation</h3>
      <p>Sèmè City est bien plus qu'un campus. C'est la "Cité Internationale de l'Innovation et du Savoir", un écosystème intégré qui regroupe formations de haut niveau, incubateurs, accélérateurs et laboratoires de recherche.</p>
      
      <h4>Opportunités pour votre PME/Startup :</h4>
      <ul>
        <li><strong>Incubation et Accélération :</strong> Si votre projet est innovant, vous pouvez postuler aux programmes d'incubation pour transformer votre idée en une entreprise viable, ou d'accélération pour booster votre croissance.</li>
        <li><strong>Accès à un vivier de talents :</strong> La proximité avec des institutions académiques de renom (comme l'École de design de Nantes Atlantique, Epitech) vous donne un accès direct aux meilleurs talents du pays.</li>
        <li><strong>Infrastructures de pointe :</strong> Accès à des espaces de co-working, des "fab labs" (ateliers de fabrication numérique) et à un environnement stimulant pour l'innovation.</li>
      </ul>
      
      <blockquote>
        "Le gouvernement crée les conditions, mais c'est à vous, entrepreneurs, de structurer vos projets pour saisir la balle au bond."
      </blockquote>
      
      <h3>Le rôle clé de votre expert-comptable pour être éligible</h3>
      <p>Accéder à ces opportunités n'est pas automatique. Cela requiert une préparation rigoureuse et des bases solides. C'est là que votre expert-comptable devient un partenaire stratégique indispensable.</p>
      
      <ul>
        <li><strong>Une comptabilité irréprochable :</strong> C'est le critère numéro un. Pour solliciter un financement ou une aide, vous devez présenter des états financiers clairs, sincères et conformes aux normes OHADA. Une comptabilité bien tenue est votre passeport pour la crédibilité.</li>
        <li><strong>Montage de business plans solides :</strong> Nous vous aidons à traduire votre vision en un plan d'affaires chiffré et argumenté, qui met en avant le potentiel de croissance, la rentabilité et les besoins de financement de manière professionnelle.</li>
        <li><strong>Optimisation fiscale :</strong> Nous nous assurons que vous bénéficiez pleinement des avantages offerts par le Label Start Up ou d'autres dispositifs d'exonération et d'allègement auxquels vous avez droit.</li>
        <li><strong>Veille stratégique :</strong> Nous suivons pour vous l'évolution des dispositifs de soutien et vous alertons sur les opportunités pertinentes pour votre secteur d'activité.</li>
      </ul>
      
      <h5>Le message est clair : le gouvernement crée les conditions, mais c'est à vous, entrepreneurs, de structurer vos projets pour saisir la balle au bond.</h5>
     
      <h3 style={{ fontSize: '1rem', fontWeight: 'bold' }}>
       Prêt à structurer votre PME pour capter les opportunités de demain ?
       Contactez notre cabinet pour un diagnostic et un plan d'action personnalisé.
      </h3>
    `,
    // image: "/assets/images/blog-benin.jpg",
    categories: ["Développement", "PME", "Bénin"],
    tags: [
      "ADPME",
      "PSIE",
      "Label Start Up",
      "Sèmè City",
      "SYSCEBNL",
      "e-Services",
    ],
    date: "22 Septembre 2025",
    author: "Expert CINEF-EC",
    authorTitle: "Consultant en développement d'entreprises",
    readTime: "12 min",
    featured: true,
  };

  // Articles similaires
  const similarBlogs = [
    {
      id: 2,
      title: "Guide pratique du SYSCEBNL pour les associations",
      image: "/assets/images/image7.png",
      date: "20 août 2025",
      category: "Comptabilité",
    },
    {
      id: 3,
      title: "Optimisation fiscale avec la plateforme e-Services",
      image: "/assets/images/image8.png",
      date: "15 août 2025",
      category: "Fiscalité",
    },
  ];

  return (
    <>
      <Header />

      <div className="blog-content py-5">
        <div className="container">
          {/* Fil d'Ariane */}
          <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites/blog" className="text-decoration-none">
                  Blog
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {blogPost.title}
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              {/* Catégorie et Titre */}
              <div className="blog-header mb-4">
                <div className="categories-badges mb-3">
                  {blogPost.categories.map((category, index) => (
                    <span key={index} className="category-badge me-2">
                      {category}
                    </span>
                  ))}
                </div>
                <h1 className="blog-title">{blogPost.title}</h1>

                {/* Métadonnées de l'article */}
                <div className="blog-meta d-flex align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{blogPost.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaUser className="meta-icon" />
                    <span>{blogPost.author}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{blogPost.readTime} de lecture</span>
                  </div>
                </div>
              </div>

              {/* Image principale */}
              {/* <div className="blog-featured-image mb-4">
                                <img src="../assets/images/image1.png" alt={blogPost.title} className="img-fluid rounded" />
                            </div> */}

              {/* Extrait de l'article */}
              <div className="blog-excerpt mb-4">
                <p className="lead">{blogPost.excerpt}</p>
              </div>

              {/* Contenu principal */}
              <div
                className="blog-body mb-5"
                dangerouslySetInnerHTML={{ __html: blogPost.content }}
              />

              {/* Tags */}
              <div className="blog-tags mb-4">
                {blogPost.tags.map((tag, index) => (
                  <Link key={index} to={``} className="blog-tag">
                    #{tag}
                  </Link>
                ))}
              </div>

              {/* Partage sur les réseaux sociaux */}
              <div className="blog-share mb-5">
                <h5 className="share-title">Partager cet article</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              {/* Bouton Retour */}
              <div className="blog-actions mb-5">
                <Link to="/actualites/blog" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour au blog
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              {/* À propos de l'auteur */}
              <div className="sidebar-widget author-widget">
                <h4 className="widget-title">À propos de l'auteur</h4>
                <div className="author-profile">
                  <div className="author-image">
                    <img
                      src="../assets/images/image5.png"
                      alt={blogPost.author}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="author-info">
                    <h5 className="author-name">{blogPost.author}</h5>
                    <p className="author-title">{blogPost.authorTitle}</p>
                    <p className="author-bio">
                      Spécialiste en accompagnement des PME au Bénin avec une
                      expertise dans les dispositifs de soutien gouvernementaux
                      et les réformes comptables OHADA.
                    </p>
                  </div>
                </div>
              </div>

              {/* Articles similaires */}
              <div className="sidebar-widget similar-blogs-widget">
                <h4 className="widget-title">Articles similaires</h4>
                <div className="similar-blogs">
                  {similarBlogs.map((similarBlog) => (
                    <Link
                      key={similarBlog.id}
                      to={`/blog/${similarBlog.id}`}
                      className="similar-blog"
                    >
                      <div className="similar-blog-image">
                        <img
                          src={similarBlog.image}
                          alt={similarBlog.title}
                          className="img-fluid rounded"
                        />
                        <span className="category-badge small">
                          {similarBlog.category}
                        </span>
                      </div>
                      <div className="similar-blog-content">
                        <h5 className="similar-blog-title">
                          {similarBlog.title}
                        </h5>
                        <div className="similar-blog-date">
                          <FaCalendarAlt className="me-1" size={12} />
                          <small>{similarBlog.date}</small>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Widget Newsletter */}
              <div className="sidebar-widget newsletter-widget">
                <h4 className="widget-title">Newsletter</h4>
                <p className="newsletter-desc">
                  Recevez nos conseils sur les opportunités d'entreprises au
                  Bénin directement dans votre boîte mail
                </p>
                <form className="newsletter-form">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    S'abonner
                  </button>
                </form>
              </div>

              {/* Widget Liens utiles */}
              <div className="sidebar-widget categories-widget">
                <h4 className="widget-title">Liens utiles</h4>
                <ul className="categories-list">
                  <li>
                    <a
                      href="https://adpme.bj/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ADPME <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://semecity.bj/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Sèmè City <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://anpe.bj/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ANPE (PSIE) <span>→</span>
                    </a>
                  </li>
                  <li>
                    <Link to="/services/comptabilite-fiscalite">
                      Nos services <span>→</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        /* Import Google Fonts pour une typographie moderne */
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap");

        /* Reset et styles de base */
        * {
          font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
            sans-serif;
        }

        .blog-content {
          background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
          min-height: 100vh;
        }

        /* Fil d'Ariane modernisé */
        .breadcrumb {
          background: transparent;
          padding: 0;
          margin: 0;
          font-size: 0.875rem;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #9ca3af;
          content: "›";
          font-size: 1.2rem;
        }

        .breadcrumb-item a {
          color: #6b7280;
          text-decoration: none;
          transition: color 0.2s ease;
          font-weight: 500;
        }

        .breadcrumb-item a:hover {
          color: #dc2626;
        }

        .breadcrumb-item.active {
          color: #1f2937;
          font-weight: 600;
        }

        /* En-tête du blog */
        .blog-header {
          margin-bottom: 2.5rem;
        }

        .categories-badges {
          margin-bottom: 1rem;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          padding: 0.375rem 1rem;
          border-radius: 20px;
          font-size: 0.813rem;
          font-weight: 600;
          letter-spacing: 0.3px;
          box-shadow: 0 2px 8px rgba(220, 38, 38, 0.15);
        }

        .blog-title {
          font-size: 2.75rem;
          font-weight: 800;
          line-height: 1.15;
          color: #111827;
          margin-bottom: 1.5rem;
          letter-spacing: -0.02em;
        }

        /* Métadonnées modernisées */
        .blog-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          padding: 1rem 0;
          border-top: 1px solid #e5e7eb;
          border-bottom: 1px solid #e5e7eb;
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .meta-icon {
          color: #dc2626;
          font-size: 1rem;
        }

        /* Image principale */
        .blog-featured-image {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          margin-bottom: 2.5rem;
        }

        .blog-featured-image img {
          width: 100%;
          height: 400px;
          display: block;
        }

        /* Extrait modernisé */
        .blog-excerpt {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-left: 4px solid #dc2626;
          padding: 1.75rem;
          border-radius: 8px;
          margin-bottom: 2.5rem;
        }

        .blog-excerpt .lead {
          font-size: 1.125rem;
          font-weight: 500;
          line-height: 1.75;
          color: #374151;
          margin: 0;
          text-align: justify;
        }

        /* Contenu du blog avec typographie améliorée */
        .blog-body {
          font-size: 1.0625rem;
          line-height: 1.8;
          color: #374151;
          text-align: justify;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
        }

        .blog-body h3 {
          font-size: 1.875rem;
          font-weight: 700;
          color: #111827;
          margin-top: 3rem;
          margin-bottom: 1.25rem;
          position: relative;
          padding-left: 1rem;
          border-left: 4px solid #dc2626;
        }

        .blog-body h4 {
          font-size: 1.375rem;
          font-weight: 600;
          color: #1f2937;
          margin-top: 2rem;
          margin-bottom: 1rem;
        }

        .blog-body h5 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #16a34a;
          margin-top: 1.5rem;
          margin-bottom: 1rem;
          padding: 1.25rem;
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-radius: 8px;
          border-left: 3px solid #16a34a;
          text-align: center;
        }

        .blog-body ul,
        .blog-body ol {
          margin: 1.5rem 0;
          padding-left: 0;
          list-style: none;
        }

        .blog-body li {
          position: relative;
          padding-left: 2rem;
          margin-bottom: 1rem;
          line-height: 1.7;
        }

        .blog-body ul li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.6rem;
          width: 8px;
          height: 8px;
          background: linear-gradient(135deg, #dc2626, #16a34a);
          border-radius: 50%;
        }

        .blog-body strong {
          color: #111827;
          font-weight: 700;
        }

        .blog-body blockquote {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-left: 4px solid #16a34a;
          padding: 2rem;
          margin: 2.5rem 0;
          border-radius: 8px;
          font-size: 1.25rem;
          font-weight: 500;
          font-style: italic;
          color: #1f2937;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        /* Tags modernisés */
        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          padding: 1.5rem 0;
          border-top: 1px solid #e5e7eb;
        }

        .blog-tag {
          background: #f3f4f6;
          color: #4b5563;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1px solid transparent;
        }

        .blog-tag:hover {
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
        }

        /* Partage social modernisé */
        .blog-share {
          padding: 2rem 0;
          border-top: 1px solid #e5e7eb;
          margin-top: 2rem;
        }

        .share-title {
          font-size: 1rem;
          font-weight: 600;
          color: #374151;
          margin-bottom: 1rem;
        }

        .social-buttons {
          display: flex;
          gap: 1rem;
        }

        .social-button {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .social-button:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        .linkedin {
          background: #0077b5;
        }
        .twitter {
          background: #1da1f2;
        }
        .facebook {
          background: #4267b2;
        }

        /* Bouton retour modernisé */
        .btn-back {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: white;
          color: #374151;
          padding: 0.875rem 1.75rem;
          border-radius: 30px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.938rem;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid #e5e7eb;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .btn-back:hover {
          background: #dc2626;
          color: white;
          transform: translateX(-4px);
          box-shadow: 0 4px 16px rgba(220, 38, 38, 0.2);
        }

        /* Sidebar modernisée */
        .sidebar-widget {
          background: white;
          border-radius: 12px;
          padding: 2rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
          border: 1px solid #f3f4f6;
          transition: all 0.3s ease;
        }

        .sidebar-widget:hover {
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .widget-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #111827;
          margin-bottom: 1.5rem;
          padding-bottom: 0.75rem;
          border-bottom: 2px solid #f3f4f6;
          position: relative;
        }

        .widget-title::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 50px;
          height: 2px;
          background: linear-gradient(to right, #dc2626, #16a34a);
        }

        /* Widget Auteur modernisé */
        .author-profile {
          text-align: center;
        }

        .author-image {
          width: 90px;
          height: 90px;
          margin: 0 auto 1.25rem;
          border-radius: 50%;
          overflow: hidden;
          border: 3px solid #f3f4f6;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .author-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .author-name {
          font-size: 1.125rem;
          font-weight: 700;
          color: #111827;
          margin-bottom: 0.25rem;
        }
        .author-title {
          font-size: 0.938rem;
          font-weight: 500;
          color: #6b7280;
          margin-bottom: 1rem;
        }
        .author-bio {
          font-size: 0.875rem;
          color: #4b5563;
          line-height: 1.6;
        }
        /* Widget Articles similaires modernisé */
        .similar-blogs .similar-blog {
          display: flex;
          gap: 1rem;
          margin-bottom: 1.5rem;
          text-decoration: none;
          color: inherit;
          transition: all 0.3s ease;
        }
        .similar-blogs .similar-blog:hover {
          transform: translateX(4px);
        }
        .similar-blog-image {
          position: relative;
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .similar-blog-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .similar-blog-image .category-badge.small {
          position: absolute;
          top: 8px;
          left: 8px;
          font-size: 0.688rem;
          padding: 0.25rem 0.75rem;
          background: linear-gradient(135deg, #dc2626, #16a34a);
          box-shadow: 0 2px 8px rgba(220, 38, 38, 0.15);
        }
        .similar-blog-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .similar-blog-title {
          font-size: 1rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 0.25rem 0;
          line-height: 1.3;
        }
        .similar-blog-date {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          font-size: 0.813rem;
          color: #6b7280;
        }
        /* Widget Newsletter modernisé */
        .newsletter-desc {
          font-size: 0.938rem;
          color: #4b5563;
          margin-bottom: 1.5rem;
          line-height: 1.6;
          text-align: center;
        }
        .newsletter-form .form-control {
          border-radius: 30px;
          padding: 0.75rem 1.5rem;
          border: 1px solid #d1d5db;
          transition: border-color 0.3s ease;
        }
        .newsletter-form .form-control:focus {
          border-color: #dc2626;
          box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);
          outline: none;
        }
        .newsletter-form .btn {
          border-radius: 30px;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          font-size: 0.938rem;
          transition: all 0.3s ease;
        }
        .newsletter-form .btn:hover {
          background: #16a34a;
          border-color: #16a34a;
          box-shadow: 0 4px 16px rgba(22, 163, 74, 0.2);
          transform: translateY(-2px);
        }
        /* Widget Liens utiles modernisé */
        .categories-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .categories-list li {
          margin-bottom: 1rem;
        }
        .categories-list li a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-decoration: none;
          color: #374151;
          font-weight: 500;
          font-size: 0.938rem;
          transition: all 0.3s ease;
        }
        .categories-list li a span {
          font-size: 1.25rem;
          color: #9ca3af;
          transition: color 0.3s ease;
        }
        .categories-list li a:hover {
          color: #dc2626;
          transform: translateX(4px);
        }
        .categories-list li a:hover span {
          color: #dc2626;
        }
        /* Responsive */
        @media (max-width: 992px) {
          .blog-title {
            font-size: 2.25rem;
          }
          .blog-meta {
            flex-direction: column;
            gap: 1rem;
          }
          .blog-body h3 {
            font-size: 1.5rem;
          }
          .sidebar-widget {
            padding: 1.5rem;
          }
          .widget-title {
            font-size: 1.125rem;
          }
          .similar-blog-image {
            width: 70px;
            height: 70px;
          }
        }
        @media (max-width: 576px) {
          .blog-title {
            font-size: 1.875rem;
          }
          .blog-body h3 {
            font-size: 1.375rem;
          }
          .blog-body h4 {
            font-size: 1.25rem;
          }
          .blog-body h5 {
            font-size: 1.125rem;
            padding: 1rem;
          }
          .similar-blog {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          .similar-blog-image {
            width: 100%;
            height: auto;
          }
          .similar-blog-content {
            align-items: center;
          }
        }
      `}</style>
    </>
  );
};
export default DetailBlog;
